// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1diPe","placeholdersHeader":"styles_placeholdersHeader__3toMT","editorStyle":"styles_editorStyle__17v-v","placeholdersBox":"styles_placeholdersBox__2e3mz"};